export default __webpack_public_path__ + "static/media/logo-shp.1ba03f4f.svg";